import { URL_TAB_NAME_HASH_KEY } from '../const';
import useSearchParams from '../../../hooks/useSearchParams';

export const useGetUrlTabParam = () => {
	const params = useSearchParams();

	const tabIdParam: string | undefined | Array<string> = params[URL_TAB_NAME_HASH_KEY];

	if (typeof tabIdParam === 'object') {
		return tabIdParam.find(Boolean);
	}

	return tabIdParam;
};
